import React, { useEffect } from "react";
import { Grid, Typography, Box } from "@material-ui/core";

import { groupChangelogByMonth } from "../../../data/changelog";
import ChangelogEntryCard from "./ChangelogEntryCard";

const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

function labelDeMes(clave) {
  const [anio, mes] = clave.split("-");
  return `${MESES[Number(mes) - 1]} ${anio}`;
}

export default function ChangelogPage() {
  // Permalinks (#id): al entrar directo a /novedades#id (o al navegar aquí
  // desde un link interno sin recarga completa), hace scroll hasta esa
  // entrada. El navegador ya lo hace solo en una carga completa de página;
  // esto cubre la navegación interna de React Router.
  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const grupos = groupChangelogByMonth();

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography variant="h2" gutterBottom>
          Novedades
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          Cambios recientes en el panel administrativo de Dashport.
        </Typography>
      </Grid>

      {grupos.map(({ mes, entries }) => (
        <Grid item key={mes}>
          <Box mt={3} mb={1}>
            <Typography variant="h5" style={{ textTransform: "capitalize" }}>
              {labelDeMes(mes)}
            </Typography>
          </Box>
          {entries.map((entry) => (
            <ChangelogEntryCard key={entry.id} entry={entry} />
          ))}
        </Grid>
      ))}
    </Grid>
  );
}
